const servicesSwiper = new Swiper('.card-swiper', {
    // Optional parameters
    loop: true,
    slidesPerView: 'auto',
    slidesPerViewAutoSlideSize: 500,
    spaceBetween: 100,
    autoplay: false,
    allowTouchMove: true, // Enable touch/swipe gestures
    speed: 800,
    navigation: {
        nextEl: '.sliding-cards .swiper-controls .next',
        prevEl: '.sliding-cards .swiper-controls .prev',
    },
});